export default __webpack_public_path__ + "static/media/forgetpass1.2ee766d8.jpg";